import './account.less';

import DashBoardHeader from '../header_dashboard/dashboard_header';
import ProfileNavBar from './profile_navbar/profile_navbar';
import validate from '../util/validate';
import {toTitleCase, join} from '../util/common';
import ShowError from '../components/error/show_error';
import authActions from '../auth/auth_actions';
import profileActions from '../profile/profile_actions';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import CONSTANTS from '../common_constants';
import React from 'react';
import {Link, browserHistory} from 'react-router';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MediaQuery from 'react-responsive';
import LoggedinFooter from '../footer/loggedin_footer';
import cookies from '../util/cookie';
import SuccessMessage from '../components/success/success_msg';
import $ from 'jquery';
import fileUploadActions from '../image_upload/file_upload_actions';

class AccountDetails extends React.Component {
    constructor(props) {
        super(props);
        const userData = props.userData;
        this.state = {
            name: userData.name,
            phoneNo: userData.phoneNumber,
            email: userData.email,
            isfblogin: userData.isFacebookLogin,
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            validationError: {},
            ajaxInProgress: false,
            successMsg : '',
            profileImageUrl : userData.profileImageUrl
        };
        this.initailState = Object.assign({}, this.state);
        this.update = this.update.bind(this);
        this.updateProfile = this.updateProfile.bind(this);
        this.updatePhoneNumber = this.updatePhoneNumber.bind(this);
    }
    componentWillReceiveProps(newProps){
      this.setState({
        profileImageUrl : newProps.userData.profileImageUrl
      })
    }
    updatePhoneNumber(){
      browserHistory.push('/enter-phoneno?isPhoneUpdate=true');
    }
    update(name, event) {
        const stateObj = {};
        stateObj[name] = event.target.value;
        this.setState(stateObj);
    }
    updateProfile(e) {
        e.preventDefault();
        this.setState({successMsg:"",error:null});
        const self = this;
        const validationError = {
            firstName: !validate.name(this.state.name),
            email: !validate.email(this.state.email),
            phoneNo: !validate.phoneNumber(this.state.phoneNo)
        };

        const validationMap = {
            firstName: 'First Name',
            email: 'Email',
            phoneNo: 'Phone number'
        };

        let errorMsg = "";
        const validationFields = [];
        Object.keys(validationError).forEach((key) => {
            if (validationError[key])
                validationFields.push(validationMap[key]);
            }
        );

        if (validationFields.length) {
            errorMsg = 'Please enter valid ' + join(validationFields, (item, idx) => {
                if (validationFields.length === 1)
                    return "";
                if (idx > 0 && idx < validationFields.length - 1)
                    return ", ";
                else if (idx === validationFields.length - 1)
                    return " and ";
                return "";
            }) + '.';
        }

        if (errorMsg) {
            this.setState({error: errorMsg, validationError: validationError, ajaxInProgress: false});
            return;
        } else {
            this.setState({error: null, validationError: validationError, ajaxInProgress: false});
        }

        const validationPasswordError = {
            oldPassword: !validate.password(this.state.oldPassword),
            newPassword: !validate.password(this.state.newPassword),
            confirmPassword: !validate.password(this.state.confirmPassword)
        };

        const validationPasswordMap = {
            oldPassword: 'Old Password',
            newPassword: 'New Password',
            confirmPassword: 'Confirm password'
        };

        errorMsg = "";
        const validationPasswordFields = [];
        Object.keys(validationPasswordError).forEach((key) => {
            if (validationPasswordError[key])
                validationPasswordFields.push(validationPasswordMap[key]);
            }
        );

        if (validationPasswordFields.length) {
            errorMsg = 'Please enter valid ' + join(validationPasswordFields, (item, idx) => {
                if (validationPasswordFields.length === 1)
                    return "";
                if (idx > 0 && idx < validationPasswordFields.length - 1)
                    return ", ";
                else if (idx === validationPasswordFields.length - 1)
                    return " and ";
                return "";
            }) + '.';
        }

        if (this.state.oldPassword != "") {
            if (errorMsg) {
                this.setState({error: errorMsg, validationError: validationError});
                return;
            }
        }
        if (this.state.newPassword != this.state.confirmPassword) {
            this.setState({error: "Passwords do not match", validationError: validationError});
            return;
        }
        if (this.state.name != this.initailState.name || this.state.email != this.initailState.email || this.state.oldPassword != "") {
            let parameters = {
                name: this.state.name,
                email: this.state.email,
                phoneNumber: this.state.phoneNo
            }
            this.setState({ajaxInProgress: true});
              if (this.state.name != this.initailState.name || this.state.email != this.initailState.email){
                this.props.profileActions.updateProfile(parameters).then(() => {
                    this.setState({ajaxInProgress: false,successMsg:"Update successful"});
                    this.initailState = Object.assign({}, this.state);
                }, (errorRes) => {
                    if(errorRes.error === CONSTANTS.sessionInvalid){
                      this.setState({ajaxInProgress: false})
                      this.props.authActions.sessionValid(false);
                      cookies.delete('_sd');
                      return ;
                    }
                    this.setState({ajaxInProgress: false,successMsg:""});
                    this.setState({error: errorRes.error, validationError: validationError});
                })
              }
            if (this.state.oldPassword != "") {
                let passParameters = {
                    oldPassword: this.state.oldPassword,
                    newPassword: this.state.newPassword
                }
                this.props.profileActions.updatePassword(passParameters).then(() => {
                    this.setState({ajaxInProgress: false,successMsg:"Update successful"});
                    this.setState({oldPassword :'',newPassword:'',confirmPassword:''});
                }, (errorRes) => {
                    if(errorRes.error === CONSTANTS.sessionInvalid){
                          this.setState({ajaxInProgress: false})
                          this.props.authActions.sessionValid(false);
                          cookies.delete('_sd');
                          return ;
                  }
                    this.setState({ajaxInProgress: false,successMsg:""});
                    this.setState({error: errorRes.error, validationError: validationError});
                })
            }
        } else {
            this.setState({error: "Make sure you have changed atleast one field", validationError: validationError});
            return;
        }
    }
    triggerUploadImg = () =>{
      $('input[type=file]').trigger('click');
    }
    getFileObject = () =>{
      let imageUrl = null;
      const self  = this;
      // here the function should return the image object
      let file = this.refs.imageUpload.files[0];
      this.setState({
        isLoading: true
      })
      fileUploadActions.shipmentImageUpload(file).then((successData)=> {
          let profileImgObj = {};
          if(successData){
            profileImgObj = {
              profileImageUrl : successData.successMessage
            }
          }
          self.props.authActions.editProfileImage(profileImgObj).then(() =>{
              this.setState({isLoading: false})
          },(errorRes) => {
              if(errorRes.error === CONSTANTS.sessionInvalid){
                this.setState({isLoading: false})
                this.props.authActions.sessionValid(false);
                cookies.delete('_sd');
                return ;
              }
              this.setState({isLoading: false,successMsg:""});
              this.setState({error: errorRes.error, validationError: validationError});
          })
      },(errorRes) => {
          if(errorRes.error === CONSTANTS.sessionInvalid){
            this.setState({isLoading: false})
            this.props.authActions.sessionValid(false);
            cookies.delete('_sd');
            return ;
          }
          this.setState({ajaxInProgress: false,successMsg:""});
          this.setState({error: errorRes.error, validationError: validationError});
      })
    }
    render() {
        const self = this;
        const {props, state} = this;
        let {ajaxInProgress} = state;
        let userProfileImage = state.profileImageUrl || "../../public/images/user_placeholder.svg";
        let profileImgLable = "Change Photo"
        if(!state.profileImageUrl)
        {
          profileImgLable = "Upload Photo"
        }
        const loader = <div className="loader-button"></div>;

        return (
            <div className="profile-account">
              <div className="heading">
                Account
              </div>
              {this.state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
              <div className="update-phone-number profile-section">
                <div className="input-set-label">
                  <label className="labels">Profile Image</label>
                    <div className="img-wrap"  style={{"backgroundImage": 'url("' + userProfileImage + '")'}}>
                  </div>
                    <div className = "profile-label" onClick = {this.triggerUploadImg}>
                      {profileImgLable}
                      <input className="displayNone" type="file" accept="image/*" ref="imageUpload" onChange={this.getFileObject} />
                    </div>
                </div>
              </div>
              <div className="update-phone-number">
                <div className="input-set-label">
                  <label className="labels">Phone</label>
                  <input className="input phone-no" type="text" onChange={this.update.bind(self, 'phoneNo')} value={state.phoneNo} placeholder="Your phone number" readOnly/>
                </div>
                <div className="input-set">
                  <label className="labels"></label>
                  <button className="btn orange input"  onClick={this.updatePhoneNumber}> Update your phone number</button>
                </div>
              </div>
              <form className="content" autoComplete="off">
                {state.error && <ShowError errorMessage={this.state.error}/>}
                {state.successMsg != '' && <SuccessMessage successMessage = {state.successMsg} />}
                <div className="input-set">
                  <label className="labels">Full name</label>
                        <input type="text" onChange={this.update.bind(self, 'name')} value={state.name} className="input" placeholder="First and last name"/>
                    </div>
                    <div className="input-set">
                        <label className="labels">Email</label>
                        <input type="text" onChange={this.update.bind(self, 'email')} value={state.email} className="input" placeholder="Email address"/>
                    </div>
                    <div className={state.isfblogin? 'displayNone': 'displayBlock'}>
                        <div className="input-set">
                            <label className="labels">Password</label>
                            <input className="input" type="password" value={state.oldPassword}onChange={this.update.bind(self, 'oldPassword')} placeholder="******"/>
                        </div>
                        <div className={(state.oldPassword != '')? 'input-set': 'displayNone'}>
                            <label className="labels">New Password</label>
                            <input className="input" type="password" value={state.newPassword}onChange={this.update.bind(self, 'newPassword')} placeholder="New password"/>
                        </div>
                        <div className={(state.oldPassword != '')? 'input-set': 'displayNone'}>
                            <label className="labels">Confirm Password</label>
                            <input className="input" type="password" value={state.confirmPassword}onChange={this.update.bind(self, 'confirmPassword')} placeholder="Confirm password"/>
                        </div>
                    </div>
                    <div className="input-set">
                        <label className="labels"></label>
                        <button className="btn orange input"  onClick={this.updateProfile}>{ajaxInProgress? loader : 'Update'}</button>
                    </div>
                </form>
              </div>
        )
    }
}

class Account extends React.Component {
    constructor(props) {
        super(props);
        this.logout = this.logout.bind(this);
    }

    logout() {
      this.props.authActions.logout().always(() => {
          cookies.delete('_sd');
          document.location.href = '/';
      });
    }

    render() {
       const {props, state} = this;
       const {userData} = props.authState;
       let sessionValid = true ;
       if("sessionValid" in props.authState.userData) sessionValid = props.authState.userData.sessionValid

       let user = {
           name: '',
           imageUrl: '',
           isVerified: '',
           creditAmount: ''
        };

       if(props.authState) {
         user.name = userData.name;
         user.imageUrl = userData.profileImageUrl;
         user.isVerified = userData.isVerified;
         user.creditAmount = userData.creditAmount
       }

        return (
            <div className="account-details-wrap account-section">
              <DashBoardHeader user={user} logout={this.logout}/>
              <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
              <div className="account-header-wrap">
                <div className="wrapper">
                  <h2 className="page-header account-page-header">Account</h2>
                </div>
              </div>
              <div className="wrapper account-wrapper">
                <div className="profile-nav-bar-component">
                  <ProfileNavBar pathname={this.props.location.pathname} userData={user}/>
                  </div>
                  <div className="account-details-component">
                    <AccountDetails authActions ={props.authActions} userData={props.authState.userData} profileActions={props.profileActions}/>
                  </div>
                </div>
                <LoggedinFooter />
            </div>
        )
    }
}
Account = connect((state) => {
    return {authState: state.app.auth, profile: state.app.profile}
}, (dispatch) => {
    return {
        routerActions: bindActionCreators(routerActions, dispatch),
        authActions: bindActionCreators(authActions, dispatch),
        profileActions: bindActionCreators(profileActions, dispatch)
    }
})(Account);

export default Account;



// WEBPACK FOOTER //
// app/profile/account.jsx